import type { ISetting } from '@dakedake/types'
import { request } from '@umijs/max'

/** 配置列表 GET /backend/setting/list */
export async function settingList(options?: Record<string, any>) {
  return request<{ data: ISetting[] }>('/backend/setting/list', {
    method: 'GET',
    ...options
  })
}

/** 获取单个配置 GET /backend/setting/get */
export async function settingGet(params?: Record<string, any>) {
  return request<{ data: ISetting }>('/backend/setting/get', {
    method: 'GET',
    params
  })
}

/** 添加配置 POST /backend/setting/add */
export async function settingAdd(body: ISetting, options?: Record<string, any>) {
  return request<{ data: ISetting[], success: boolean, message: string }>('/backend/setting/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 删除 POST /backend/setting/delete */
export async function settingDelete(body: { id: number }, options?: Record<string, any>) {
  return request<{ data: ISetting, success: boolean, message: string }>('/backend/setting/delete', {
    method: 'DELETE',
    data: body,
    ...options
  })
}
